module.exports = __webpack_public_path__ + "static/media/ENH.1ce4ddf2.png";